<template>
	<div v-if="asset" :class="['category-image', type]">
		<img
			:class="['billboard', billboardPosition]"
			src="@/assets/images/categories/billboard.png"
			alt=""
		/>
		<img
			v-if="billboardAsset"
			:src="billboardAsset"
			:class="['logo', billboardPosition]"
			alt=""
		/>
		<img
			v-else
			src="@/assets/images/small-default-billboard.png"
			:class="['logo', billboardPosition]"
			alt=""
		/>
		<img
			class="building-image"
			:src="require(`@/assets/images/${asset}.png`)"
			alt=""
		/>
	</div>
</template>
<script>
export default {
	props: {
		asset: {
			type: String,
			default: null
		},
		billboardAsset: {
			type: String,
			default: null
		},
		billboardPosition: {
			type: String,
			default: 'left'
		},
		type: {
			type: String,
			default: 'category-header',
			validator: value => {
				return ['category-header', 'page-header'].includes(value);
			}
		}
	}
};
</script>
<style lang="scss" scoped>
.category-image {
	position: relative;
	height: 480px;
	background-size: cover;

	&.category-header {
		background-image: url('../../../assets/images/backgrounds/category-header.png');
	}

	&.page-header {
		background-image: url('../../../assets/images/backgrounds/page-header.png');
	}

	.billboard {
		position: absolute;

		&.left {
			top: 40px;
			left: 70px;
		}
		&.right {
			top: 15px;
			right: 5px;
		}
	}

	.building-image {
		position: absolute;
		bottom: 0;
		left: 0;
		right: 0;
		margin: auto;
		max-width: 100%;
	}

	.logo {
		position: absolute;
		height: 52px;
		width: 140px;
		margin: 10px;

		&.left {
			top: 43px;
			left: 72px;
		}
		&.right {
			top: 18px;
			right: 88px;
		}
	}
}
</style>
